import { Component } from "@angular/core";
import {
  FormControl,
  FormGroup,
  Validators,
  ValidatorFn,
} from "@angular/forms";
import { UserAdminsService } from "../user-admins.service";
import { AuthService } from "../../auth/auth.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "../../shared/toastr.service";
import { TranslateService } from "@ngx-translate/core";
import { LimitPlanDialogComponent } from "../../shared/limit-plan-dialog/limit-plan-dialog.component";
import { AddAdminReq } from "../user-admins.interface";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../shared/error-state-matcher";

@Component({
  selector: "app-user-admins-create-dialog",
  templateUrl: "./user-admins-create-dialog.component.html",
  styleUrls: ["./user-admins-create-dialog.component.scss"],
  standalone: false,
})
export class UserAdminsCreateDialogComponent {
  public sendingRequest = false;
  public form: FormGroup;
  public errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();

  constructor(
    private service: UserAdminsService,
    public auth: AuthService,
    public dialogRef: MatDialogRef<UserAdminsCreateDialogComponent>,
    private toastr: ToastrService,
    private translate: TranslateService,
    private dialog: MatDialog,
  ) {
    const defaultRole =
      this.auth.isGroupManager || this.auth.isReseller
        ? "GROUP_MANAGER"
        : "COMPANY_MANAGER";
    const requiredValidator: ValidatorFn = Validators.required.bind(
      null,
    ) as ValidatorFn;
    const emailValidator: ValidatorFn = Validators.email.bind(
      null,
    ) as ValidatorFn;
    this.form = new FormGroup({
      email: new FormControl("", [requiredValidator, emailValidator]),
      role: new FormControl(defaultRole, [requiredValidator]),
    });
  }

  submit = () => {
    this.errorStateMatcher.submitAttempted = true;
    if (this.form.invalid) {
      return;
    }
    this.sendingRequest = true;
    const formValue = this.form.value as { email: string; role: string };
    this.service.addAdmin(formValue as AddAdminReq).subscribe({
      next: () => this.close(formValue),
      error: (error: unknown) => {
        this.sendingRequest = false;
        const errorObj = error as {
          error?: { message?: string } | string;
          message?: string;
        };
        let errorMessage = "";
        if (typeof errorObj?.error === "object" && errorObj?.error?.message) {
          errorMessage = errorObj.error.message;
        } else if (errorObj?.message) {
          errorMessage = errorObj.message;
        } else if (typeof errorObj?.error === "string") {
          errorMessage = errorObj.error;
        }
        if (
          errorMessage.includes("ADMIN_LIMIT_REACHED") ||
          errorMessage.includes("Admin limit reached")
        ) {
          this.dialogRef.close();
          this.dialog.open(LimitPlanDialogComponent, {
            width: "500px",
            maxWidth: "90vw",
            data: { plan: "basic", type: "admin" },
          });
        } else if (
          errorMessage.includes("COMPANY_MANAGER_MULTIPLE_DOMAINS") ||
          errorMessage.includes("Opcja niedostępna") ||
          errorMessage.includes(
            "pracownik posiada role w więcej niż jednej domenie",
          )
        ) {
          this.toastr.error(
            this.translate.instant(
              "userAdmins.companyManagerMultipleDomainsError",
            ) as string,
          );
        } else {
          this.toastr.error(
            this.translate.instant("userAdmins.addError") as string,
          );
        }
      },
    });
  };

  close = (response: unknown) => this.dialogRef.close(response);
}
